module.exports = __webpack_public_path__ + "img/download-icon.bf0cd969.svg";